import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { withRouter } from 'react-router-dom';

import purple from '@material-ui/core/colors/purple';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.up('sm')]: {
        marginTop: 11,
    },
    marginTop:6,
    width: `100%`,
  },
  cssLabel: {
    '&$cssFocused': {
      color: purple[500],
    },
  },
  cssFocused: {},
  cssUnderline: {
    '&:after': {
      borderBottomColor: purple[500],
    },
  },
  bootstrapRoot: {
    padding: 0,
    'label + &': {
      marginTop: theme.spacing.unit * 3,
    },
  },
  bootstrapInput: {
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 12px',
    width: 'calc(100% - 24px)',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  bootstrapFormLabel: {
    fontSize: 18,
  },
});


class SearchInput extends React.Component {
    state = {
        value: '',
        toEventDetails: false,
        currentLocation: '',
    };
    catchReturn = (e) => {
        if (e.key === 'Enter' && this.state.value.trim().length > 0) {
            this.props.toggleDrawer();
            this.props.displayLoadIndicator(true);
            this.props.updateTitle('Search Results','for '+this.state.value,-1,NaN);
            fetch("https://www.seatingsymposium.us/app/rest/presentations/search?keyword="+this.state.value).then(response => response.json()).then(result => this.onSetResult(result));
            this.props.history.push(`/event-schedule/search?keyword=${this.state.value}`);
        }
    }

    onSetResult = (result) => {
      this.props.updateSearchResults(this.state.value,result);
      this.setState({value: ''});
      setTimeout(() => this.props.displayLoadIndicator(false),700);
    };

    handleChange = (e) => {
        this.setState({value: e.target.value});
    }

    render() {
        const { classes } = this.props;

        return (
          <Grid container className={classes.container}>
          <Grid item xs={12} >
            <Grid container justify="flex-end" alignItems="center" direction="column" >
            <TextField
                placeholder="Search..."
                id="search"
                onChange={this.handleChange}
                onKeyPress={this.catchReturn}
                value={this.state.value}
                InputProps={{
                disableUnderline: true,
                classes: {
                    root: classes.bootstrapRoot,
                    input: classes.bootstrapInput,
                },
                }}
                InputLabelProps={{
                shrink: true,
                className: classes.bootstrapFormLabel,
                }}
            />
            </Grid>
            </Grid>
            
            </Grid>
        );
    }
}

SearchInput.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  updateSearchResults: PropTypes.func.isRequired,
  displayLoadIndicator: PropTypes.func.isRequired,
  updateTitle: PropTypes.func,
};

export default withRouter(withStyles(styles)(SearchInput));